/**
 *
 *
 */

/* 배송상태 */
export const InquirySubType = {
  // 1:1 문의
  JM_PAY: { value: 'JM_PAY', label: '제이엠페이 관련' }, //
  JM_PAY_REFUND: { value: 'JM_PAY_REFUND', label: '환불 신청' }, //
  USER: { value: 'USER', label: '회원정보' }, //
  SERVICE: { value: 'SERVICE', label: '서비스' }, //

  // 공통 문의
  DELIVERY: { value: 'DELIVERY', label: '배송' }, //
  BULK: { value: 'BULK', label: '대량문의' }, //
  ORDER: { value: 'ORDER', label: '주문/결제' }, //
  ETC: { value: 'ETC', label: '기타' }, //기
  STORE: { value: 'STORE', label: '매장' }, //매

  // 상품 관련
  DETAIL: { value: 'DETAIL', label: '상세' }, //
  RESTOCK: { value: 'RESTOCK', label: '재입고' }, //
};
